import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../../../Context'
import { getPaymentProductHistoryAsync, getPaymentHistoryDetailAsync, getPaymentVoucherAsync, getPaymentPDFAsync } from '../../../services/historyService';
import { UseLoadingSvg } from '../../../hooks/useLoadingSvg';
import { Modal } from '../../../hooks/useModal';
import ReactTable from "react-table";
import Grid from "@material-ui/core/Grid";
import { UseDateTime } from '../../../hooks/useDateTime';
import useStyles from '../../../styles/GlobalStyles';
import { Voucher } from '../../vouchers/voucher';
import { Loader } from 'react-overlay-loader';

export const HistoryPayment = () => {
    const classes = useStyles()
    const[productList, setProductList] = useState([])
    const[historyDetail, setHistoryDetail] = useState([])
    const[loading, setLoading] = useState(true)
    const[open, setOpen] = useState(false)
    const[isOpen, setOpenVoucher] = useState(false)
    const[vouncherData, setVouncherData] = useState([])
    const[loadingVoucher, setLoadingVoucher] = useState(false)
    const { isAuth, removeAuth } = useContext(Context);
  
    const handleClickOpen = index => {
      var historySeleted = productList[index]
      GetPaymentHistoryDetailAsync(historySeleted.paymentTicket)
      setOpen(true);
    }

    const handleClickOpenVoucher = index => {
      var historySeleted = productList[index]
      GetPaymentVoucherAsync(historySeleted.paymentTicket)
    }
  
    const handleClose = () => {
      setOpen(false);
      setOpenVoucher(false)
    }

    const onClose = e => {
      setOpenVoucher(false)
    }

    const openModal = (information) => {
      setVouncherData(information)
      setOpenVoucher(true)
    }
    
    async function handlePrint() {
      const user = JSON.parse(localStorage.getItem('user'))
      if(user != null){
        var response = await getPaymentPDFAsync(vouncherData)
        const linkSource = `data:application/pdf;base64,${response}`;
        const downloadLink = document.createElement("a");
        const fileName = "ComprobantePago_" + vouncherData.paymentID + ".pdf";
    
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }else {
        removeAuth(false)
      }
    }
  
    async function GetPaymentHistoryDetailAsync (paymentNumber) {
      const user = JSON.parse(localStorage.getItem('user'))
      if(user != null){
        var response = await getPaymentHistoryDetailAsync(paymentNumber)
        response.map(item => item.date = UseDateTime(item.expirationDate, "LLL"))
        setHistoryDetail(response);
      } else {
        removeAuth(false)
      }
    }

    async function GetPaymentVoucherAsync (paymentNumber) {
      const user = JSON.parse(localStorage.getItem('user'))
      if(user != null){
        setLoadingVoucher(true)
        var response = await getPaymentVoucherAsync(paymentNumber)
        const user = JSON.parse(localStorage.getItem('user'))
        response.email = user.Email
        openModal(response)
        setLoadingVoucher(false)
      } else {
        removeAuth(false)
      }
    }
  
    async function GetPaymentProductHistoryAsync () {
      const user = JSON.parse(localStorage.getItem('user'))
      if(user != null){
        var response = await getPaymentProductHistoryAsync()
        response.map(item => item.date = UseDateTime(item.date, "LLL"))
        setProductList(response)
        setLoading(false)
      } else {
        removeAuth(false)
      }
    }

    async function GetPaymentDetailHistory(row){
      handleClickOpen(row.index)
    }

    async function GetPaymentVoucher(row){
      handleClickOpenVoucher(row.index)
    }

    useEffect(() => {
        setLoading(true)
        GetPaymentProductHistoryAsync()
    }, [])

    const columnas = [
        {
          Header : "NUMERO DE PAGO",
          accessor : "paymentId",
          Cell : properties => {
            return [
              <p>{properties.original.paymentId}</p>
            ]
          },
          sortable : true,
          style : {
            textAlign : "right"
          }
        },
        {
          Header : "FECHA DE PAGO",
          accessor : "date",
          Cell : properties => {
            return [
              <p>{new Date(properties.original.date).toLocaleString()}</p>
            ]
          },
          sortable : true,
          style : {
            textAlign : "center"
          }
        },
        {
          Header : "ESTADO",
          accessor : "statusPayment",
          Cell : properties => {
            return [
              <p>{properties.original.statusPayment}</p>
            ]
          },
          sortable : true,
          style : {
            textAlign : "left"
          }
        },
        {
          Header : "VALOR",
          accessor : "totalAmount",
          Cell : properties => {
            return [
              <p>{properties.original.totalAmount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</p>
            ]
          },
          sortable : true,
          style : {
            textAlign : "right"
          }
        },
        {
          Header : "",
          Cell: (row) => {
            return <a onClick={()=>GetPaymentDetailHistory(row)}>Ver detalle</a>
          },
          sortable : true,
          style : {
            color : "blue"
          }
        },
        {
          Header : "",
          Cell: (row) => {
            return <a onClick={()=>GetPaymentVoucher(row)}>Ver comprobante</a>
          },
          sortable : true,
          style : {
            color : "blue"
          }
        }
    ];

    const columnDetail = [
      {
        Header : "REFERENCIA",
        accessor : "productReferenceNumber",
        Cell : properties => {
          return [
            <p>{properties.original.productReferenceNumber}</p>
          ]
        },
        style : {
          textAlign : "right",
          width : '100%'
        }
      },
      {
        Header : "DESCRIPCION",
        accessor : "referenceDesc",
        Cell : properties => {
          return [
            <p>{properties.original.referenceDesc}</p>
          ]
        },
        style : {
          textAlign : "left",
          width : '100%'
        }
      },
      {
        Header : "MONEDA",
        accessor : "currency",
        Cell : properties => {
          return [
            <p>{properties.original.currency}</p>
          ]
        },
        sortable : true,
        style : {
          textAlign : "left"
        }
      },
      {
        Header : "VALOR",
        accessor : "amount",
        Cell : properties => {
          return [
            <p>{properties.original.amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</p>
          ]
        },
        sortable : true,
        style : {
          textAlign : "right"
        }
      }
    ];

    return(
      <Grid container className={classes.grid} justify="center">
        <Loader fullPage loading loading={loadingVoucher} text={"Cargando..."}/>
        <Grid item xs={12} sm={12} md={8} lg={7} className={classes.gridItem}>
          {
            loading ?
              <UseLoadingSvg />
            :
              <>
                      <ReactTable
                        multiSort = {true}
                        columns = {columnas}
                        data = {productList}
                        selectableRows = {false}
                        style = {{cursor: 'pointer', width : '100%', height:'100%'}}
                      />
                      <Modal maxWidth="md"
                            isOpen={open}
                            onClose={handleClose}
                            titleModal = "DETALLE DE LA TRANSACCIÓN"
                        >
                        <ReactTable
                            data = {historyDetail}
                            multiSort = {true}
                            expanded = {true}
                            columns = {columnDetail}
                            defaultPageSize = {5}
                            minRows = {0}
                            selectableRows = {false}
                            style = {{width : '100%' }}
                            showPagination = {false}
                        />
                      </Modal>
              </>
          }
        </Grid>
        <Modal isOpen = {isOpen} 
               onClose = {onClose} 
               maxWidth = "md" 
               scroll = {true}
               actionsFooter
               handleClose={handleClose}
               handlePrint={handlePrint}>
          <Voucher {...vouncherData} />
        </Modal>
      </Grid>
    )
}